import CollectionOrderList from "../symbols/collectionOrderList";

const initialState = {
  data: [],
  totalCount: null,
  loading: false,
  error: false,
  selectedTab: 0,
};

export default function CollectionReducer(state = initialState, action: any) {
  switch (action.type) {
    case CollectionOrderList.COLLECTION_ORDER_LIST_SUCCESS:
      if (state.totalCount) {
        let temp = [
          ...state.data,
          ...action.payload.Result.Data,
        ];

        return {
          ...state,
          data: temp,
          loading: false,
          error: false,
        };
      } else {
        return {
          ...state,
          data: action.payload.Result.Data,
          totalCount: action.payload.Result.Count,
          loading: false,
          error: false,
        };
      }

    case CollectionOrderList.COLLECTION_ORDER_LIST_FAILURE:
      return {
        ...state,
        data: initialState.data,
        totalCount: initialState.totalCount,
        loading: false,
        error: true,
      };
    case CollectionOrderList.COLLECTION_ORDER_LIST:
      return {
        ...state,
        loading: true,
      };
    case CollectionOrderList.CLEAR_COLLECTION_ORDER_LIST:
      return {
        ...state,
        data: initialState.data,
        totalCount: initialState.totalCount,
        loading: false,
        error: false,
      };
    case CollectionOrderList.COLLECTION_ORDER_SET_SELECTED_TAB:
      return { ...state, selectedTab: action.payload };
    default:
      return state;
  }
}
